<div class="auth-wrapper">

  <mat-card class="auth-card">
    <mat-card-content>

      <h2 class="title">Reset Password</h2>
      <p class="subtitle">Create a new password for your account.</p>

      <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>New Password</mat-label>
          <input matInput [type]="showPassword ? 'text' : 'password'" formControlName="password" />
          <button mat-icon-button matSuffix type="button" (click)="showPassword = !showPassword">
            <mat-icon class="d-flex align-items-center">
              <i-tabler [name]="showPassword ? 'eye-off' : 'eye'" class="icon-18 d-flex"></i-tabler>
            </mat-icon>
          </button>
          <mat-error *ngIf="form.get('password')?.hasError('required')">
            Password is required
          </mat-error>
          <mat-error *ngIf="form.get('password')?.hasError('minlength')">
            Minimum 6 characters
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Confirm Password</mat-label>
          <input matInput [type]="showConfirmPassword ? 'text' : 'password'" formControlName="password_confirmation" />
          <button mat-icon-button matSuffix type="button" (click)="showConfirmPassword = !showConfirmPassword">
            <mat-icon class="d-flex align-items-center">
              <i-tabler [name]="showConfirmPassword ? 'eye-off' : 'eye'" class="icon-18 d-flex"></i-tabler>
            </mat-icon>
          </button>
          <mat-error *ngIf="form.errors?.['mismatch']">
            Passwords do not match
          </mat-error>
        </mat-form-field>

        <button mat-flat-button color="primary" class="w-100" [disabled]="form.invalid || loading">
          {{ loading ? 'Updating...' : 'Update Password' }}
        </button>

      </form>

      <div class="back-link">
        <a routerLink="/customer/signin">← Back to Sign In</a>
      </div>

    </mat-card-content>
  </mat-card>

</div>
